/* fix/product-options — block direct ATC when Product Customizer finish is required
   Covers: theme cards, Convermax search (.cm_product-item), CBB Also Bought */
(function () {
  const CACHE_PREFIX = 'pf-pc:';
  const DONE_ATTR = 'data-pf-pc-guarded';
  const cache = new Map();

  const SELECTORS = {
    themeForm: 'product-form[data-pf-pc-check="true"]',
    themeSubmit: 'product-form[data-pf-pc-check="true"] [type="submit"], .card-wrapper product-form [type="submit"]',
    cmItem: '.cm_product-item',
    cmForm: '.cm_product-item__buttons-form',
    cmSubmit: '.cm_product-item__buttons-form button[type="submit"], .cm_product-item__buttons-form .cm_button__primary',
    cbbItem: '.cbb-also-bought-product',
    cbbSubmit: '.cbb-also-bought-add-to-cart-button',
  };

  function chooseOptionsLabel() {
    return window.themeStrings?.chooseOptions || 'Choose options';
  }

  function normalizeUrl(url) {
    try {
      return new URL(url, window.location.origin).pathname;
    } catch (e) {
      return url;
    }
  }

  function readCache(path) {
    if (cache.has(path)) return cache.get(path);
    try {
      const stored = sessionStorage.getItem(CACHE_PREFIX + path);
      if (stored === '1') return true;
      if (stored === '0') return false;
    } catch (e) {
      /* ignore */
    }
    return null;
  }

  function writeCache(path, hasPc) {
    cache.set(path, hasPc);
    try {
      sessionStorage.setItem(CACHE_PREFIX + path, hasPc ? '1' : '0');
    } catch (e) {
      /* ignore */
    }
  }

  async function productHasPcOptions(productUrl) {
    const path = normalizeUrl(productUrl);
    const cached = readCache(path);
    if (cached !== null) return cached;

    try {
      const response = await fetch(path, { credentials: 'same-origin' });
      if (!response.ok) {
        writeCache(path, false);
        return false;
      }
      const html = await response.text();
      const hasPc = html.includes('data-has-pc-app="true"');
      writeCache(path, hasPc);
      return hasPc;
    } catch (e) {
      writeCache(path, false);
      return false;
    }
  }

  function productUrlFrom(el) {
    if (!el) return null;
    if (el.dataset?.productUrl) return el.dataset.productUrl;

    const withAttr = el.closest('[data-product-url]');
    if (withAttr?.dataset?.productUrl) return withAttr.dataset.productUrl;

    const cmItem = el.closest(SELECTORS.cmItem);
    if (cmItem) {
      const titleLink = cmItem.querySelector('a.cm_product-item__title[href*="/products/"], a.cm_product-item__image-container[href*="/products/"], a[href*="/products/"]');
      if (titleLink) return titleLink.getAttribute('href');
    }

    const cbbItem = el.closest(SELECTORS.cbbItem);
    if (cbbItem) {
      const link = cbbItem.querySelector('a[href*="/products/"]');
      if (link) return link.getAttribute('href');
    }

    const card = el.closest('.card-wrapper, .product-card-wrapper');
    if (card) {
      const link = card.querySelector('a[href*="/products/"]');
      if (link) return link.getAttribute('href');
    }

    return null;
  }

  function buildChooseOptionsLink(href, className, id) {
    const link = document.createElement('a');
    link.href = href;
    link.className = className || 'button';
    link.textContent = chooseOptionsLabel();
    link.setAttribute('data-pf-pc-options', 'true');
    if (id) link.id = id;
    return link;
  }

  async function replaceIfPc(container, control, url) {
    if (!container || !control || !url) return;
    if (container.getAttribute(DONE_ATTR) === 'true') return;
    container.setAttribute(DONE_ATTR, 'pending');

    const hasPc = await productHasPcOptions(url);
    if (!hasPc) {
      container.setAttribute(DONE_ATTR, 'true');
      return;
    }

    if (!control.isConnected) return;

    const link = buildChooseOptionsLink(normalizeUrl(url), control.className, control.id || '');
    link.setAttribute('role', 'button');

    // Convermax: replace whole add form so submit cannot fire
    const cmForm = control.closest(SELECTORS.cmForm);
    if (cmForm) {
      cmForm.replaceWith(link);
    } else if (control.closest('product-form')) {
      control.closest('product-form').replaceWith(link);
    } else {
      control.replaceWith(link);
    }

    container.setAttribute(DONE_ATTR, 'true');
  }

  function scan(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll?.(SELECTORS.themeForm).forEach((form) => {
      if (form.getAttribute(DONE_ATTR) === 'true') return;
      const submit = form.querySelector('[type="submit"]');
      replaceIfPc(form, submit, productUrlFrom(form));
    });

    scope.querySelectorAll?.(SELECTORS.cmItem).forEach((item) => {
      if (item.getAttribute(DONE_ATTR) === 'true') return;
      const submit = item.querySelector(SELECTORS.cmSubmit);
      replaceIfPc(item, submit, productUrlFrom(item));
    });

    scope.querySelectorAll?.(SELECTORS.cbbItem).forEach((item) => {
      if (item.getAttribute(DONE_ATTR) === 'true') return;
      const submit = item.querySelector(SELECTORS.cbbSubmit);
      replaceIfPc(item, submit, productUrlFrom(item));
    });
  }

  function isGuardedControl(el) {
    if (!el || el.dataset?.pfPcPass === '1') return null;
    if (el.closest?.('[data-pf-pc-options="true"]')) return null;

    const cbb = el.closest?.(SELECTORS.cbbSubmit);
    if (cbb) return cbb;

    const cm = el.closest?.(SELECTORS.cmSubmit);
    if (cm) return cm;

    const theme = el.closest?.(SELECTORS.themeSubmit);
    if (theme) return theme;

    // Form submit fallback (Convermax)
    if (el.matches?.(SELECTORS.cmForm) || el.closest?.(SELECTORS.cmForm)) {
      return el.closest(SELECTORS.cmForm)?.querySelector('button[type="submit"]') || el;
    }

    return null;
  }

  document.addEventListener(
    'click',
    function (event) {
      const btn = isGuardedControl(event.target);
      if (!btn) return;

      const url = productUrlFrom(btn);
      if (!url) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const path = normalizeUrl(url);
      const cached = readCache(path);

      const proceed = (hasPc) => {
        if (hasPc) {
          window.location.href = path;
          return;
        }
        btn.dataset.pfPcPass = '1';
        btn.click();
        delete btn.dataset.pfPcPass;
      };

      if (cached !== null) {
        proceed(cached);
        return;
      }

      btn.setAttribute('aria-disabled', 'true');
      productHasPcOptions(url).then((hasPc) => {
        btn.removeAttribute('aria-disabled');
        proceed(hasPc);
      });
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!form?.classList?.contains('cm_product-item__buttons-form')) return;

      const url = productUrlFrom(form);
      if (!url) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const path = normalizeUrl(url);
      productHasPcOptions(url).then((hasPc) => {
        if (hasPc) {
          window.location.href = path;
          return;
        }
        form.dataset.pfPcPass = '1';
        HTMLFormElement.prototype.submit.call(form);
      });
    },
    true
  );

  function boot() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Convermax / CBB inject late and re-render on filter/sort
  const observer = new MutationObserver((mutations) => {
    let shouldScan = false;
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          node.matches?.(
            `${SELECTORS.cmItem}, ${SELECTORS.cbbItem}, ${SELECTORS.themeForm}, ${SELECTORS.cmForm}, .cm_product-list, .cbb-also-bought-container, product-recommendations`
          ) ||
          node.querySelector?.(
            `${SELECTORS.cmItem}, ${SELECTORS.cbbItem}, ${SELECTORS.themeForm}, ${SELECTORS.cmForm}`
          )
        ) {
          shouldScan = true;
          break;
        }
      }
      if (shouldScan) break;
    }
    if (shouldScan) scan(document);
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
